/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { User } from 'app/core/user/user.types';
import { PathEnum } from 'app/modules/shared/enums/pathEnum';
import { RoleEnum } from 'app/modules/shared/enums/roleEnum';
import { UserUtil } from 'app/modules/shared/utils/user.util';

export const defaultNavigation: FuseNavigationItem[] = [

    // PARTNER
    {
        id   : 'menu',
        title: 'Menu',
        type : 'basic',
        icon : 'heroicons_outline:book-open',
        link : PathEnum.APP_PARTNER_MENU,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.APR]);
            return res;
        }

    },
    {
        id   : 'partner-dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-bar',
        link : PathEnum.APP_PARTNER_DASHBOARD,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.APR]);
            return res;
        }

    },
    {
        id   : 'qr-code',
        title: 'QR Code',
        type : 'basic',
        icon : 'heroicons_outline:qr-code',
        link : PathEnum.APP_PARTNER_QRCODE,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.APR]);
            return res;
        }
    },
    {
        id   : 'settingsP',
        title: 'Partner Settings',
        type : 'basic',
        icon : 'heroicons_outline:cog-8-tooth',
        link : PathEnum.APP_PARTNER_SETTINGS,
        hidden: (elem) => { 
            let res: boolean = checkDisplayFor(elem, [RoleEnum.PSA, RoleEnum.PAD]);
            return res;
        }
    },
    
    // TEAM
    {
        id   : 'team-dashboard',
        title: 'analytics-team',
        type : 'basic',
        icon : 'heroicons_outline:chart-bar',
        link : PathEnum.APP_TEAM_DASHBOARD,
        hidden: (elem) => { 
            let res: boolean = checkDisplayFor(elem, [RoleEnum.ATR]);
            return res;
        }

    },
    {
        id   : 'partners',
        title: 'Partners',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : PathEnum.APP_PARTNERS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.ATR]);
            return res;
        }

    },
    {
        id   : 'affiliate-applications',
        title: 'Affiliate Applications',
        type : 'basic',
        icon : 'heroicons_outline:inbox',
        link : PathEnum.APP_TEAM_AFFILIATE_APPLICATIONS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        }
    },
    {
        id   : 'affiliates',
        title: 'Affiliates',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : PathEnum.APP_TEAM_AFFILIATES,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        }
    },
    {
        id   : 'affiliate-payouts',
        title: 'Affiliate Payouts',
        type : 'basic',
        icon : 'heroicons_outline:banknotes',
        link : PathEnum.APP_TEAM_AFFILIATE_PAYOUTS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        }
    },
    {
        id   : 'team-whatsapp',
        title: 'WhatsApp',
        type : 'collapsable',
        icon : 'heroicons_outline:chat-bubble-left-right',
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        },
        children: [
            {
                id   : 'team-whatsapp.inbox',
                title: 'Inbox',
                type : 'basic',
                icon : 'heroicons_outline:inbox',
                link : '/' + PathEnum.APP_TEAM + '/' + PathEnum.APP_TEAM_WHATSAPP + '/' + PathEnum.APP_TEAM_WHATSAPP_INBOX,
            },
            {
                id   : 'team-whatsapp.templates',
                title: 'Templates',
                type : 'basic',
                icon : 'heroicons_outline:document-text',
                link : '/' + PathEnum.APP_TEAM + '/' + PathEnum.APP_TEAM_WHATSAPP + '/' + PathEnum.APP_TEAM_WHATSAPP_TEMPLATES,
            },
            {
                id   : 'team-whatsapp.settings',
                title: 'Settings',
                type : 'basic',
                icon : 'heroicons_outline:cog-8-tooth',
                link : '/' + PathEnum.APP_TEAM + '/' + PathEnum.APP_TEAM_WHATSAPP + '/' + PathEnum.APP_TEAM_WHATSAPP_SETTINGS,
            }
        ]
    },
    {
        id   : 'team-partner-tasks',
        title: 'Partner tasks',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-document-list',
        link : '/' + PathEnum.APP_TEAM + '/' + PathEnum.APP_TEAM_PARTNER_TASKS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        }
    },
    {
        id   : 'settingsT',
        title: 'Team Settings',
        type : 'basic',
        icon : 'heroicons_outline:cog-8-tooth',
        link : PathEnum.APP_TEAM_SETTINGS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.ATR]);
            return res;
        }
    },

];

export const compactNavigation: FuseNavigationItem[] = [

    // PARTNER
    {
        id   : 'menu',
        title: 'Menu',
        type : 'basic',
        icon : 'heroicons_outline:book-open',
        link : PathEnum.APP_PARTNER_MENU,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.APR]);
            return res;
        }

    },
    {
        id   : 'partner-dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-bar',
        link : PathEnum.APP_PARTNER_DASHBOARD,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.APR]);
            return res;
        }

    },
    {
        id   : 'qr-code',
        title: 'QR Code',
        type : 'basic',
        icon : 'heroicons_outline:qr-code',
        link : PathEnum.APP_PARTNER_QRCODE,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.APR]);
            return res;
        }
    },
    {
        id   : 'establishment',
        title: 'Establishment',
        type : 'basic',
        icon : 'heroicons_outline:building-storefront',
        link : PathEnum.APP_PARTNER_ESTABLISHMENT,
        hidden: (elem) => { 
            let res: boolean = checkDisplayFor(elem, [RoleEnum.APR]);
            return res;
        }

    },
    
    // TEAM
    {
        id   : 'team-dashboard',
        title: 'analytics-team',
        type : 'basic',
        icon : 'heroicons_outline:chart-bar',
        link : PathEnum.APP_TEAM_DASHBOARD,
        hidden: (elem) => { 
            let res: boolean = checkDisplayFor(elem, [RoleEnum.ATR]);
            return res;
        }

    },
    {
        id   : 'partners',
        title: 'Partners',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : PathEnum.APP_PARTNERS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.ATR]);
            return res;
        }

    },
    {
        id   : 'affiliate-applications',
        title: 'Affiliate Applications',
        type : 'basic',
        icon : 'heroicons_outline:inbox',
        link : PathEnum.APP_TEAM_AFFILIATE_APPLICATIONS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        }
    },
    {
        id   : 'affiliates',
        title: 'Affiliates',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : PathEnum.APP_TEAM_AFFILIATES,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        }
    },
    {
        id   : 'affiliate-payouts',
        title: 'Affiliate Payouts',
        type : 'basic',
        icon : 'heroicons_outline:banknotes',
        link : PathEnum.APP_TEAM_AFFILIATE_PAYOUTS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        }
    },
    {
        id   : 'team-whatsapp',
        title: 'WhatsApp',
        type : 'collapsable',
        icon : 'heroicons_outline:chat-bubble-left-right',
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        },
        children: [
            {
                id   : 'team-whatsapp.inbox',
                title: 'Inbox',
                type : 'basic',
                icon : 'heroicons_outline:inbox',
                link : '/' + PathEnum.APP_TEAM + '/' + PathEnum.APP_TEAM_WHATSAPP + '/' + PathEnum.APP_TEAM_WHATSAPP_INBOX,
            },
            {
                id   : 'team-whatsapp.templates',
                title: 'Templates',
                type : 'basic',
                icon : 'heroicons_outline:document-text',
                link : '/' + PathEnum.APP_TEAM + '/' + PathEnum.APP_TEAM_WHATSAPP + '/' + PathEnum.APP_TEAM_WHATSAPP_TEMPLATES,
            },
            {
                id   : 'team-whatsapp.settings',
                title: 'Settings',
                type : 'basic',
                icon : 'heroicons_outline:cog-8-tooth',
                link : '/' + PathEnum.APP_TEAM + '/' + PathEnum.APP_TEAM_WHATSAPP + '/' + PathEnum.APP_TEAM_WHATSAPP_SETTINGS,
            }
        ]
    },
    {
        id   : 'team-partner-tasks',
        title: 'Partner tasks',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-document-list',
        link : '/' + PathEnum.APP_TEAM + '/' + PathEnum.APP_TEAM_PARTNER_TASKS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        }
    },
    {
        id   : 'settingsT',
        title: 'Team Settings',
        type : 'basic',
        icon : 'heroicons_outline:cog-8-tooth',
        link : PathEnum.APP_TEAM_SETTINGS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.ATR]);
            return res;
        }
    },

];

export const futuristicNavigation: FuseNavigationItem[] = [

    // PARTNER
    {
        id   : 'menu',
        title: 'Menu',
        type : 'basic',
        icon : 'heroicons_outline:book-open',
        link : PathEnum.APP_PARTNER_MENU,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.APR]);
            return res;
        }

    },
    {
        id   : 'partner-dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-bar',
        link : PathEnum.APP_PARTNER_DASHBOARD,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.APR]);
            return res;
        }

    },
    {
        id   : 'qr-code',
        title: 'QR Code',
        type : 'basic',
        icon : 'heroicons_outline:qr-code',
        link : PathEnum.APP_PARTNER_QRCODE,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.APR]);
            return res;
        }
    },
    {
        id   : 'establishment',
        title: 'Establishment',
        type : 'basic',
        icon : 'heroicons_outline:building-storefront',
        link : PathEnum.APP_PARTNER_ESTABLISHMENT,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.APR]);
            return res;
        }

    },

    // TEAM
    {
        id   : 'team-dashboard',
        title: 'analytics-team',
        type : 'basic',
        icon : 'heroicons_outline:chart-bar',
        link : PathEnum.APP_TEAM_DASHBOARD,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.ATR]);
            return res;
        }

    },
    {
        id   : 'partners',
        title: 'Partners',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : PathEnum.APP_PARTNERS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.ATR]);
            return res;
        }

    },
    {
        id   : 'affiliate-applications',
        title: 'Affiliate Applications',
        type : 'basic',
        icon : 'heroicons_outline:inbox',
        link : PathEnum.APP_TEAM_AFFILIATE_APPLICATIONS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        }
    },
    {
        id   : 'affiliates',
        title: 'Affiliates',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : PathEnum.APP_TEAM_AFFILIATES,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        }
    },
    {
        id   : 'affiliate-payouts',
        title: 'Affiliate Payouts',
        type : 'basic',
        icon : 'heroicons_outline:banknotes',
        link : PathEnum.APP_TEAM_AFFILIATE_PAYOUTS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        }
    },
    {
        id   : 'team-whatsapp',
        title: 'WhatsApp',
        type : 'collapsable',
        icon : 'heroicons_outline:chat-bubble-left-right',
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        },
        children: [
            {
                id   : 'team-whatsapp.inbox',
                title: 'Inbox',
                type : 'basic',
                icon : 'heroicons_outline:inbox',
                link : '/' + PathEnum.APP_TEAM + '/' + PathEnum.APP_TEAM_WHATSAPP + '/' + PathEnum.APP_TEAM_WHATSAPP_INBOX,
            },
            {
                id   : 'team-whatsapp.templates',
                title: 'Templates',
                type : 'basic',
                icon : 'heroicons_outline:document-text',
                link : '/' + PathEnum.APP_TEAM + '/' + PathEnum.APP_TEAM_WHATSAPP + '/' + PathEnum.APP_TEAM_WHATSAPP_TEMPLATES,
            },
            {
                id   : 'team-whatsapp.settings',
                title: 'Settings',
                type : 'basic',
                icon : 'heroicons_outline:cog-8-tooth',
                link : '/' + PathEnum.APP_TEAM + '/' + PathEnum.APP_TEAM_WHATSAPP + '/' + PathEnum.APP_TEAM_WHATSAPP_SETTINGS,
            }
        ]
    },
    {
        id   : 'team-partner-tasks',
        title: 'Partner tasks',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-document-list',
        link : '/' + PathEnum.APP_TEAM + '/' + PathEnum.APP_TEAM_PARTNER_TASKS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        }
    },
    {
        id   : 'settingsT',
        title: 'Team Settings',
        type : 'basic',
        icon : 'heroicons_outline:cog-8-tooth',
        link : PathEnum.APP_TEAM_SETTINGS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.ATR]);
            return res;
        }
    },

];

export const horizontalNavigation: FuseNavigationItem[] = [

    // PARTNER
    {
        id   : 'menu',
        title: 'Menu',
        type : 'basic',
        icon : 'heroicons_outline:book-open',
        link : PathEnum.APP_PARTNER_MENU,
        hidden: (elem) => { 
            let res: boolean = checkDisplayFor(elem, [RoleEnum.APR]);
            return res;
        }

    },
    {
        id   : 'partner-dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-bar',
        link : PathEnum.APP_PARTNER_DASHBOARD,
        hidden: (elem) => { 
            let res: boolean = checkDisplayFor(elem, [RoleEnum.APR]);
            return res;
        }

    },
    {
        id   : 'qr-code',
        title: 'QR Code',
        type : 'basic',
        icon : 'heroicons_outline:qr-code',
        link : PathEnum.APP_PARTNER_QRCODE,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.APR]);
            return res;
        }
    },
    {
        id   : 'establishment',
        title: 'Establishment',
        type : 'basic',
        icon : 'heroicons_outline:building-storefront',
        link : PathEnum.APP_PARTNER_ESTABLISHMENT,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.APR]);
            return res;
        }

    },

    // TEAM
    {
        id   : 'team-dashboard',
        title: 'analytics-team',
        type : 'basic',
        icon : 'heroicons_outline:chart-bar',
        link : PathEnum.APP_TEAM_DASHBOARD,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.ATR]);
            return res;
        }

    },
    {
        id   : 'partners',
        title: 'Partners',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : PathEnum.APP_PARTNERS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.ATR]);
            return res;
        }

    },
    {
        id   : 'affiliate-applications',
        title: 'Affiliate Applications',
        type : 'basic',
        icon : 'heroicons_outline:inbox',
        link : PathEnum.APP_TEAM_AFFILIATE_APPLICATIONS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        }
    },
    {
        id   : 'affiliates',
        title: 'Affiliates',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : PathEnum.APP_TEAM_AFFILIATES,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        }
    },
    {
        id   : 'affiliate-payouts',
        title: 'Affiliate Payouts',
        type : 'basic',
        icon : 'heroicons_outline:banknotes',
        link : PathEnum.APP_TEAM_AFFILIATE_PAYOUTS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        }
    },
    {
        id   : 'team-whatsapp',
        title: 'WhatsApp',
        type : 'collapsable',
        icon : 'heroicons_outline:chat-bubble-left-right',
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        },
        children: [
            {
                id   : 'team-whatsapp.inbox',
                title: 'Inbox',
                type : 'basic',
                icon : 'heroicons_outline:inbox',
                link : '/' + PathEnum.APP_TEAM + '/' + PathEnum.APP_TEAM_WHATSAPP + '/' + PathEnum.APP_TEAM_WHATSAPP_INBOX,
            },
            {
                id   : 'team-whatsapp.templates',
                title: 'Templates',
                type : 'basic',
                icon : 'heroicons_outline:document-text',
                link : '/' + PathEnum.APP_TEAM + '/' + PathEnum.APP_TEAM_WHATSAPP + '/' + PathEnum.APP_TEAM_WHATSAPP_TEMPLATES,
            },
            {
                id   : 'team-whatsapp.settings',
                title: 'Settings',
                type : 'basic',
                icon : 'heroicons_outline:cog-8-tooth',
                link : '/' + PathEnum.APP_TEAM + '/' + PathEnum.APP_TEAM_WHATSAPP + '/' + PathEnum.APP_TEAM_WHATSAPP_SETTINGS,
            }
        ]
    },
    {
        id   : 'team-partner-tasks',
        title: 'Partner tasks',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-document-list',
        link : '/' + PathEnum.APP_TEAM + '/' + PathEnum.APP_TEAM_PARTNER_TASKS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.TSA, RoleEnum.TAD]);
            return res;
        }
    },
    {
        id   : 'settingsT',
        title: 'Team Settings',
        type : 'basic',
        icon : 'heroicons_outline:cog-8-tooth',
        link : PathEnum.APP_TEAM_SETTINGS,
        hidden: (elem) => {
            let res: boolean = checkDisplayFor(elem, [RoleEnum.ATR]);
            return res;
        }
    },

];

// Dedicated navigation for the affiliate self-service portal.
// AffiliateUser is its own user type (AFF) — these items are NEVER shown to
// partner / team users, and conversely team / partner items never appear here.
export const affiliateNavigation: FuseNavigationItem[] = [
    {
        id   : 'affiliate-portal-dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-bar',
        link : '/' + PathEnum.APP_AFFILIATE + '/' + PathEnum.APP_AFFILIATE_PORTAL + '/' + PathEnum.APP_AFFILIATE_PORTAL_DASHBOARD,
        // No `hidden` filter — affiliateNavigation is only returned to AffiliateUsers.
    },
    {
        id   : 'affiliate-portal-link',
        title: 'My Link',
        type : 'basic',
        icon : 'heroicons_outline:link',
        link : '/' + PathEnum.APP_AFFILIATE + '/' + PathEnum.APP_AFFILIATE_PORTAL + '/' + PathEnum.APP_AFFILIATE_PORTAL_LINK,
        // No `hidden` filter — affiliateNavigation is only returned to AffiliateUsers.
    },
    {
        id   : 'affiliate-portal-referred',
        title: 'Referred Partners',
        type : 'basic',
        icon : 'heroicons_outline:user-group',
        link : '/' + PathEnum.APP_AFFILIATE + '/' + PathEnum.APP_AFFILIATE_PORTAL + '/' + PathEnum.APP_AFFILIATE_PORTAL_REFERRED,
        // No `hidden` filter — affiliateNavigation is only returned to AffiliateUsers.
    },
    {
        id   : 'affiliate-portal-commissions',
        title: 'My Commissions',
        type : 'basic',
        icon : 'heroicons_outline:currency-dollar',
        link : '/' + PathEnum.APP_AFFILIATE + '/' + PathEnum.APP_AFFILIATE_PORTAL + '/' + PathEnum.APP_AFFILIATE_PORTAL_COMMISSIONS,
        // No `hidden` filter — affiliateNavigation is only returned to AffiliateUsers.
    },
    {
        id   : 'affiliate-portal-payouts',
        title: 'My Payouts',
        type : 'basic',
        icon : 'heroicons_outline:banknotes',
        link : '/' + PathEnum.APP_AFFILIATE + '/' + PathEnum.APP_AFFILIATE_PORTAL + '/' + PathEnum.APP_AFFILIATE_PORTAL_PAYOUTS,
        // No `hidden` filter — affiliateNavigation is only returned to AffiliateUsers.
    },
    {
        id   : 'affiliate-portal-settings',
        title: 'Settings',
        type : 'basic',
        icon : 'heroicons_outline:cog-8-tooth',
        link : '/' + PathEnum.APP_AFFILIATE + '/' + PathEnum.APP_AFFILIATE_PORTAL + '/' + PathEnum.APP_AFFILIATE_PORTAL_SETTINGS,
        // No `hidden` filter — affiliateNavigation is only returned to AffiliateUsers.
    },
];

function checkDisplayFor(elem: FuseNavigationItem, val: RoleEnum[]) {
    let res = true;
    if (elem && elem.meta && elem.meta.displayFor) {
        const user: User = elem.meta.displayFor;
        // Check for all partner roles
        if(UserUtil.isPartnerUser(user) && val.includes(RoleEnum.APR)){
            res = false;
        }
        // Check for all team-staff roles. AffiliateUser is now its own user type
        // (AFF) — no longer a TeamUser — so isTeamUser already excludes affiliates.
        if(UserUtil.isTeamUser(user) && val.includes(RoleEnum.ATR)){
            res = false;
        }

        // Check role by role
        if(user.roles.some(role => val.includes(role as RoleEnum))){
            res = false;
        }

    }
    return res;
}